import styled from 'styled-components';


const FormInfoContainer = styled.div`
  position: relative;
  grid-area: form-info;
  align-self: center;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .lock{
    position: relative;
    height: 50px;
    width: 50px;
    margin-right: 15px;
    border-radius: 100%;
    background-color: #819da0;
    font-size: 23px;
    color: #fff;
    flex-shrink: 0;

    i{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }

    p{
      margin: 0;
      font-family: 'Montserrat',Sans-Serif;
      font-size: 15px;
      line-height: 18px;
    }
  }
`

export default FormInfoContainer


// WEBPACK FOOTER //
// ./src/components/containers/wizard/FormInfoContainer.tsx